"use strict";

var processInclude = require("base/js/util");

$(document).ready(function () {
    processInclude(require("../../minifiedJs/productDetail"));
    processInclude(require("./experience/components/pdp/pdpAddToCartUX"));
    // processInclude(require("./product/custom"));
    processInclude(require("./product/customDetailPage"));
});
